import Vue from 'vue'
import NuxtjsStickySidebar from '~/node_modules/nuxtjs-sticky-sidebar/dist/nuxtjs-sticky-sidebar.esm'

Vue.use(NuxtjsStickySidebar)
